"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userKeeper = exports.getCoreKeeper = exports.coreKeeperAppReady = exports.coreKeeperAPI = void 0;
var global_1 = require("./keeper/global");
Object.defineProperty(exports, "coreKeeperAPI", { enumerable: true, get: function () { return global_1.coreKeeperAPI; } });
Object.defineProperty(exports, "coreKeeperAppReady", { enumerable: true, get: function () { return global_1.coreKeeperAppReady; } });
Object.defineProperty(exports, "getCoreKeeper", { enumerable: true, get: function () { return global_1.getCoreKeeper; } });
Object.defineProperty(exports, "userKeeper", { enumerable: true, get: function () { return global_1.userKeeper; } });
//# sourceMappingURL=index.js.map